
export class Story {
  id: number;
  name: string;
  isBlock: boolean;
  imageUrl: string;
  bookmark?: number;
  firstStepId: number;

  constructor(
    id: number,
    name: string,
    isBlock: boolean,
    image: string,
    firstStepId: number,
    bookmark?: number,
  ) {
    this.id = id;
    this.name = name;
    this.isBlock = isBlock;
    this.imageUrl = image;
    this.bookmark = bookmark;
    this.firstStepId = firstStepId;
  }
}
